import { create } from 'zustand'

export const useCV = create((set) => ({
  scene: 0,        // 0-12
  progress: 0,     // 0-1 within scene
  globalProgress: 0, // 0-1 overall
  setScene: (scene, progress = 0) => set({ scene, progress }),
  setProgress: (progress) => set({ progress }),
  setGlobalProgress: (p) => set({ globalProgress: p }),

  // Scene 4 (convolution) interactive controls
  kernelId: 'sobelX',
  setKernelId: (kernelId) => set({ kernelId }),
  useWebcam: false,
  setUseWebcam: (useWebcam) => set({ useWebcam }),
}))
